import React from 'react';

const Success = () => <p>Success! Your trade proposal has been processed</p>;

export default Success;
